import { render, staticRenderFns } from "./ReservationAdmin.vue?vue&type=template&id=5edaf6e8&scoped=true&"
import script from "./ReservationAdmin.vue?vue&type=script&lang=js&"
export * from "./ReservationAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ReservationAdmin.vue?vue&type=style&index=0&id=5edaf6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edaf6e8",
  null
  
)

export default component.exports